module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/silver-lining-1200x630.69016b03.jpg";